export const sv = {
    homeScreen : {
        startConversation: 'Starta en konversation',
        newConversationButton: 'FÅ HJÄLP',
        newMessageButton: '+ Nytt Meddelande',
        allTopics: 'Alla ämnen',
        allChatsButton: 'Se alla',
        poweredBy: 'Skapad av Richpanel',
        reOpenConversation: 'Öppna konversationen igen',
        recentConversations: 'Dina konversationer',
        startAChat: 'Starta chatten',
        noRecentConversations: 'Inga nya konversationer',
        noRecentOrders: 'Inga nya beställningar',
        haveAQuestion: "Har du en fråga eller vill bara säga hej? Vi skulle gärna höra från dig.",
        conversationClosed: `Denna konversation har markerats som avslutad. Om du har några frågor angående det här problemet, öppna den här konversationen igen.`,
        retry: 'Försök igen',
        errorOccured: 'Ett fel inträffade vid behandlingen av din förfrågan.',
        successMessage: 'Vi har fått din förfrågan och teamet kommer att kontakta {email} inom kort',
        loadingMessage: 'PVänta. Vi skickar in din förfrågan.',
        goHome: 'OKEJ',
        sendUsMessage: 'skicka ett meddelande till oss',
        endChat: 'AVSLUTA CHAT',
        goto: 'Gå till',
    },

    orderStatuses: {
        'completed': 'Completed',
        'pending': 'Pending',
        'on hold': 'On hold',
        'processing': 'Processing',
        'cancelled': 'Cancelled',
        'fulfilled': 'Fulfilled',
        'confirmed': 'Confirmed',
    },

    loginScreen: {
        title: 'Logga in på hjälpcenter',
        titleForOrdersScreenForward: 'Logga in för att se beställningar',
        userIdFieldTitle: "Din telefon eller e-post",
        userIdFieldPlaceHolder: "Ange telefon / e-postadress",
        sendCode: "ENTER",
        enterCode: 'Ange koden vi skickade',
        enterTheCode: 'Skriv in koden',
        notYourUserId: 'Inte din {userIdType}?',
        userIdTypes: {
            'phone': 'nummer',
            'email': 'mejl',
        },
        change: 'Ändra',
        notReceivedCode: "Om du inte fick koden?",
        resendCode: 'Skicka igen',
        in: 'in',
        verifyCode: 'Verifiera',
        logout: 'Logga ut',
        orderNumberFieldTitle: 'Ditt ordernummer',
        orderNumberFieldPlaceholder: 'Skriv ditt ordernummer ex 10000',
        zipcodeFieldTitle: 'Ditt kolinummer',
        zipcodeFieldPlaceholder: 'Skriv ditt kollinummer',
        emailFieldTitle: 'Mejl',
        emailFieldPlaceholder: 'Skriv din mejl',
    },

    orderList : {
        reorder: 'BESTÄLL IGEN',
        getHelp: 'FÅ HJÄLP',
        startNewConversation: '+Nytt Meddelande',
        viewPreviousOrder:'VISA ALLA BESTÄLLNINGAR',
        seeAll: 'Se alla',
        viewMoreOrders: 'VISA MER BESTÄLLNINGAR',
        viewOrderStatus: 'VISA ORDERSTATUS',
        chatWithUs: 'CHATTA MED OSS',
        issueWithPreviousOrder:'HJÄLP MED TIDIGARE BESTÄLLNING' ,
        orderLabel: 'ORDER',
        help: 'HJÄLP',
        lastOrder: 'Senaste beställning',
        selectRelevantItems: 'Välj produkt',
        selectItemsErrorMsg: 'Välj produkt för att fortsätta',
        selectAll: 'Välj alla',
        selectQuantity: 'Hur många produkter?',
        helpWithThisOrder: 'Hjälp med denna order',
        yourOrders: 'Visa dina beställningar',
        view: 'VISA',
        track: 'SPÅRA',
        addressTitle: 'Ordersammanfattning',
        billingAddressTitle: 'FAKTURAADRESS',
        shippingAddressTitle: 'LEVERANSADRESS',
        receiptTitle: 'produkter',
        itemTotal: 'Produkter Totalt',
        taxes: 'Moms',
        discounts: 'Rabatter', 
        giftCard: 'Presentkort', 
        deliveryCharges: 'Leveransavgift',
        total: 'Totalt',
        loginToViewOrders: 'Befintlig kund?',
        loginSuggestion: "Få hjälp med din order eller hjälp med att lägga en beställning",
        trackingOrderLabel: 'Spåra beställning',
        shipmentDescription: "Kom tillbaka till den här sidan för uppdateringar om din leveransstatus",
        free: "fri",
        selectedItems: "Valda Produkter",
        items: "produkter",
        "orderSearchPlaceholder": 'Filter by order #',
        "noOrderFound": 'Inga beställningar som matchar {orderId}',
    },
    chatListScreen: {
        header: 'Dina konversationer',
    },
    sentences: {
        "IN_A_DAY" : "Vår kundtjänst svarar vanligtvis på en dag.",
        "IN_FEW_MINUTES": "Vår kundtjänst svarar vanligtvis på några minuter.",
        "IN_FEW_HOURS": "Vår kundtjänst svarar vanligtvis på några timmar.",
        "AS_SOON_AS_THEY_CAN": "Vår kundtjänst svarar så fort de kan.",
        "BACK_ON": "Tillbaka på",
        "BACK_IN": "Tillbaka in",
        "HOURS": "Timmar",
        "MINUTES": 'Minuter',
        provideBelowDetails: "Vänligen ange nedanstående detaljer",
    },
    inputFields: {
        submitted: 'lämnats'
    },
    inputPropDisplayNames: {
        "email": "Mejl",
        "phone": "Telefon",
        "Phone": "Telefon",
        "firstName": "Förnamn",
        "lastName": "Efternamn",
        "uid": "Användar Id",
        "campaign": "UTM Campaign",
        "medium": "UTM Medium",
        "googleplus": "Google plus",
        "shippingPhone": "Frakt telefon",
        "source": "UTM Källa",
        "lastOrderAt": "Senaste beställningstid",
        "firstOrderAt": "Första beställningstiden",
        "visits": "Sessioner",
        "facebook": "Facebook",
        "twitter": "Twitter",
        "updatedAt": "Sågs senast",
        "createdAt": "Sågs först",
        "linkedin": "Linkedin",
        "instagram": "Instgram",
        "pinterest": "Pinterest",
        "tumblr": "Tumblr",
        "billingEmail": "Faktura mejl",
        "billingPhone": "Faktura telefon",
        "shippingEmail": "Frakt mejl",
        "state": "Stat",
        "city": "Stad",
        "country": "Land",
        "deviceType": "Typ av enhet",
        "browserName": "Webbläsare",
        "osName": "Operativsystem",
        "platform": "platform",
        "ltv": "CLV",
        "ordersCount": "Orderantal",
        "name": "Namn",
        "RichpanelPredictedCLV": "Förutsedd CLV",
        "RichpanelAliveProbability": "Sannolikhet att köpa",
        "RichpanelNextOrderDate": "Nästa beställningsdatum",
        "RichpanelPredictedOrderCount": "Förutsedd orderantal",
        "aov": "AOV",
        "WebsiteURL":"Hemsida URL"
    },
    botMessages: {
        EXISITING_CUSTOMER: 'Är du en existerande kund?',
        YES_EXISITING_CUSTOMER: "Ja, jag är kund",
        NO_EXISITING_CUSTOMER: "Nej, jag är inte kund ännu",
        GIVE_THE_TEAM_WAY_TO_REACH_YOU: "Ge kundservice möjligheten att nå dig.",
        YOU_WILL_BE_NOTIFIED_EMAIL: "Du kommer att meddelas här och via e-post ({email}) när de svarar.",
        YOU_WILL_BE_NOTIFIED_NO_EMAIL: "Du kommer att meddelas här när de svarar.",
        LEAVE_YOUR_MESSAGE: "Du kommer att meddelas här när de svarar.",
        TEAM_WILL_BE_BACK_IN:"Kundservice är tillbaka om {hours} timmar",
        TEAM_WILL_BE_BACK_ON:"Kundservice kommer tillbaka på {availableAt}",
        FEW_MORE_DETAILS: "Tack! Lite fler uppgifter hjälper oss att tilldela dig rätt person:",
    },
    initialForm: {
        heading: 'Ange dina uppgifter för att starta chatten',
        startChat: 'Starta Chat'
    },
    customerJourneyPreChatForm: {
        heading: 'Starta en chat',
        startChat: 'Starta chat',
        proceed: 'Forsätt',
        canWeHelpWithAnythingElse: 'Kan vi hjälpa dig med något annat?',
        yes: 'Ja',
        no: 'Nej',
        noThanks: "Okej tack",
        yesContactSupport: "Chatta med kundservice",
        contactSupport: "Kontakta Kundservice",
    },
    rating: {
        askedHeader: 'Betygsätt din konversation',
        successHeader: 'Du betygsatte denna konversation',
        thanksMessage: "Tack för att du meddelade oss",
        placeholderForRatingFeedback: "Vänligen skriv din feedback"
    },
    placeholders: {
        emojiSearch: 'Sök Emoji',
        typeAMessage: 'Skriv ett meddelande',
        searchGifs: 'Sök GIFs',
    },
    lastMessageText: {
        sentAGif: 'Sök Emoji',
        sharedFile: 'Dela en fil',
        askedForQualificationDetails: 'Frågade om kvalificeringsinformation.',
        askedForRating: 'Be om betyg',
        askedForFeedback: 'Be om feedback',
        sharedOrderSummary: "Delad orderöversikt"
    },
    greetingAnimation: {
        weAreOnline: 'Vi är online',
        askUsAnything: 'Ställ en fråga till oss',
        chatWithUs: 'Chatta med oss'
    },
    errorMessages: {
        enterEmailOrPhone:  "Ange e-post / telefon",
        enterValidOrPhone: "Ange giltig e-post / telefon",
        userNotFound: "Vi kunde inte hitta ett konto med den här telefonnumret / e-postadressen",
        enterCode: 'Ange inloggningskod',
        invalidCode: 'Ogiltig kod'
    }
}